module.exports = __webpack_public_path__ + "img/skrill.b8b5aaad.svg";